import { IResourceComponentsProps } from "@refinedev/core";
import { AntdInferencer } from "@refinedev/inferencer/antd";
import Cw8Show from "components/cw8/Cw8Show";

export const FragmentPubsShow: React.FC<IResourceComponentsProps> = () => {
    // return <AntdInferencer />;

    const resourceName :string = 'fragmentPub';
    return (
        <Cw8Show
            resourceName = {resourceName}
        ></Cw8Show>
    );         
};
